export default (name: string, properties: any[]): string => {
    let className = name;

    {properties.map((property) => {
            if (property !== undefined && property !== '') {
                className += ` ${name}--${property}`;
            }
        });
    }

    return className;
};


// WEBPACK FOOTER //
// ./src/utils/ClassName.tsx